var map = {
	"./competition_0_1/cabbage.png": 1068,
	"./competition_0_1/goat.png": 7196,
	"./competition_0_1/wolf.png": 5361,
	"./default/african_girl.svg": 6915,
	"./default/eskimos.svg": 4065,
	"./default/ice.svg": 923,
	"./default/nest.svg": 2724,
	"./default/seal.svg": 8741,
	"./devices/cam.png": 8817,
	"./devices/cooler.png": 7140,
	"./devices/cpu.png": 3154,
	"./devices/keyboard.png": 6577,
	"./devices/memory.png": 9867,
	"./devices/mic.png": 6053,
	"./devices/monitor_pc.png": 7224,
	"./devices/mouse.png": 6557,
	"./devices/oak.svg": 7911,
	"./devices/printer.png": 9664,
	"./devices/ram.png": 1276,
	"./rules/back.png": 2839,
	"./rules/dino.png": 4394,
	"./rules/fingers.png": 1418,
	"./rules/food.png": 5354,
	"./rules/monitor_rule.png": 261,
	"./rules/rest.png": 7820,
	"./rules/socket.png": 9469,
	"./rules/start.png": 7216,
	"./rules/window.png": 8978,
	"./rules/wires.png": 4326,
	"./year3_lesson28/fawn.png": 9678,
	"./year3_lesson28/labyrinth.png": 5805,
	"./year3_lesson28/mermaid.png": 3909,
	"./year3_lesson28/waterman.png": 5893,
	"./year3_lesson7/acorns.png": 3547,
	"./year3_lesson7/bumps.png": 4998,
	"./year3_lesson7/nectar.png": 3906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2286;